<p-dialog
  [className]="'eccc'"
  [header]="title"
  [closable]="false"
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '500px'}"
  [minY]="500"
  [maximizable]="false"
  [autoZIndex]="false">

  <div>
       <span [innerHTML]="message"></span>
      {{translatedMessage}}
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <div class="float-right">
        <button id="closeBtn" type="button" class="btn btn-secondary" (click)="closeDialog()">{{'COMMON.actionsLabel.CLOSE' | translate}}</button>
      </div>
    </div>
  </ng-template>

</p-dialog>
